export const SET_SUBDOMAIN = 'SET_SUBDOMAIN';
export const CLEAR_SUBDOMAIN = 'CLEAR_SUBDOMAIN';

